import React from "react";

import { mdiFullscreen, mdiPlus } from "@mdi/js";
import Icon, { Stack } from "@mdi/react";

import type { JSX } from "react";

export default function SpecificRuleIcon(): JSX.Element {
  return (
    <div className="bg-primary/10 overflow-hidden rounded-full">
      <Stack size={1.25}>
        <Icon
          className="text-primary p-1.25"
          path={mdiFullscreen}
          size={1.0625}
        />
        <Icon className="text-primary p-1.25" path={mdiPlus} size={0.6875} />
      </Stack>
    </div>
  );
}
